document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pnew-root]').forEach(function (root) {
    initGallery(root);
    initCardTag(root);
    initRandomViewers(root);
    initQuantity(root);
    initVariants(root);
    initProductForm(root);
    initReviewCount(root);
    initFloatingTikTok(root);
  });

  initInlineTikTokEmbeds();
});

function initGallery(root) {
  const mainMedia = root.querySelector('.pnew__main-media');
  const mainImage = root.querySelector('.pnew__main-image');
  const thumbsWrap = root.querySelector('[data-product-thumbs]');
  const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));

  if (!mainMedia || !mainImage || !thumbsWrap || !thumbs.length) return;

  thumbsWrap.style.direction = 'ltr';

  function normalizeUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      u.search = '';
      return u.href;
    } catch (e) {
      return (url || '').split('?')[0];
    }
  }

  function getVisibleThumbs() {
    return thumbs.filter(function (thumb) {
      return thumb.style.display !== 'none';
    });
  }

  function getActiveThumb() {
    return root.querySelector('[data-thumb].is-active');
  }

  function findThumbByImage(imageUrl) {
    if (!imageUrl) return null;
    const target = normalizeUrl(imageUrl);

    return thumbs.find(function (thumb) {
      const src = thumb.getAttribute('data-image');
      return normalizeUrl(src) === target;
    }) || null;
  }

  function resetThumbsToStart() {
    thumbsWrap.scrollLeft = 0;
  }

  function ensureThumbVisible(thumb) {
    if (!thumb) return;

    const wrapRect = thumbsWrap.getBoundingClientRect();
    const thumbRect = thumb.getBoundingClientRect();

    if (thumbRect.left < wrapRect.left) {
      thumbsWrap.scrollLeft -= (wrapRect.left - thumbRect.left + 8);
      return;
    }

    if (thumbRect.right > wrapRect.right) {
      thumbsWrap.scrollLeft += (thumbRect.right - wrapRect.right + 8);
    }
  }

  function setActiveThumbOnly(thumb) {
    thumbs.forEach(function (t) {
      t.classList.remove('is-active');
    });

    if (thumb) {
      thumb.classList.add('is-active');
    }
  }

  function setMainFromThumb(thumb, options) {
    if (!thumb) return;

    const opts = options || {};
    const newSrc = thumb.getAttribute('data-image');
    if (!newSrc) return;

    if (normalizeUrl(mainImage.currentSrc || mainImage.src) !== normalizeUrl(newSrc)) {
      mainImage.src = newSrc;
      mainImage.srcset = '';
    }

    setActiveThumbOnly(thumb);

    if (opts.scrollMode === 'start') {
      resetThumbsToStart();
    } else if (opts.scrollMode === 'visible') {
      ensureThumbVisible(thumb);
    }
  }

  function syncActiveThumbWithMainImage(scrollMode) {
    const matchedThumb = findThumbByImage(mainImage.currentSrc || mainImage.src);
    if (!matchedThumb) return;

    setActiveThumbOnly(matchedThumb);

    if (scrollMode === 'start') {
      resetThumbsToStart();
    } else if (scrollMode === 'visible') {
      ensureThumbVisible(matchedThumb);
    }
  }

  function moveTo(step) {
    const visible = getVisibleThumbs();
    if (!visible.length) return;

    let active = getActiveThumb();

    if (!active || active.style.display === 'none') {
      active = findThumbByImage(mainImage.currentSrc || mainImage.src);
    }

    let index = visible.indexOf(active);
    if (index === -1) index = 0;

    index += step;

    if (index < 0) index = visible.length - 1;
    if (index >= visible.length) index = 0;

    setMainFromThumb(visible[index], { scrollMode: 'visible' });
  }

  thumbsWrap.addEventListener('click', function (e) {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    if (thumb.style.display === 'none') return;

    setMainFromThumb(thumb, { scrollMode: 'visible' });
  });

  let startX = 0;
  let startY = 0;
  let dragging = false;

  mainMedia.addEventListener('touchstart', function (e) {
    if (!e.touches || !e.touches.length) return;

    const t = e.touches[0];
    startX = t.clientX;
    startY = t.clientY;
    dragging = true;
  }, { passive: true });

  mainMedia.addEventListener('touchend', function (e) {
    if (!dragging) return;
    dragging = false;

    if (!e.changedTouches || !e.changedTouches.length) return;

    const t = e.changedTouches[0];
    const dx = t.clientX - startX;
    const dy = t.clientY - startY;

    if (Math.abs(dx) < 35) return;
    if (Math.abs(dy) > Math.abs(dx)) return;

    if (dx < 0) {
      moveTo(1);
    } else {
      moveTo(-1);
    }
  }, { passive: true });

  let mouseDown = false;
  let mouseStartX = 0;
  let mouseStartY = 0;

  mainMedia.addEventListener('mousedown', function (e) {
    mouseDown = true;
    mouseStartX = e.clientX;
    mouseStartY = e.clientY;
  });

  window.addEventListener('mouseup', function (e) {
    if (!mouseDown) return;
    mouseDown = false;

    const dx = e.clientX - mouseStartX;
    const dy = e.clientY - mouseStartY;

    if (Math.abs(dx) < 35) return;
    if (Math.abs(dy) > Math.abs(dx)) return;

    if (dx < 0) {
      moveTo(1);
    } else {
      moveTo(-1);
    }
  });

  mainImage.addEventListener('load', function () {
    syncActiveThumbWithMainImage('none');
  });

  let lastVisibleSignature = '';

  function buildVisibleSignature() {
    return getVisibleThumbs()
      .map(function (thumb) {
        return thumb.getAttribute('data-image') || '';
      })
      .join('|');
  }

  function syncAfterThumbVisibilityChange() {
    const visible = getVisibleThumbs();
    if (!visible.length) return;

    const active = getActiveThumb();
    const currentMatched = findThumbByImage(mainImage.currentSrc || mainImage.src);

    if (!active || active.style.display === 'none') {
      if (currentMatched && currentMatched.style.display !== 'none') {
        setMainFromThumb(currentMatched, { scrollMode: 'start' });
      } else {
        setMainFromThumb(visible[0], { scrollMode: 'start' });
      }
    } else {
      setActiveThumbOnly(active);
      resetThumbsToStart();
    }
  }

  const observer = new MutationObserver(function () {
    const newSignature = buildVisibleSignature();
    if (newSignature !== lastVisibleSignature) {
      lastVisibleSignature = newSignature;
      syncAfterThumbVisibilityChange();
    }
  });

  thumbs.forEach(function (thumb) {
    observer.observe(thumb, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  });

  const matchedThumb = findThumbByImage(mainImage.currentSrc || mainImage.src);
  const firstVisible = getVisibleThumbs()[0];

  if (matchedThumb && matchedThumb.style.display !== 'none') {
    setMainFromThumb(matchedThumb, { scrollMode: 'start' });
  } else if (firstVisible) {
    setMainFromThumb(firstVisible, { scrollMode: 'start' });
  }

  lastVisibleSignature = buildVisibleSignature();

  root._gallerySetMainFromThumb = function (thumb, startFromBeginning) {
    setMainFromThumb(thumb, {
      scrollMode: startFromBeginning ? 'start' : 'visible'
    });
  };

  root._gallerySyncActiveThumbWithMainImage = function (startFromBeginning) {
    syncActiveThumbWithMainImage(startFromBeginning ? 'start' : 'visible');
  };

  root._galleryResetThumbsToStart = resetThumbsToStart;
}

function initCardTag(root) {
  const tag = root.querySelector('.pnew__card-tag');
  const text = root.querySelector('.pnew__card-tag-text');
  if (!tag || !text) return;

  const isRTL = document.documentElement.dir === 'rtl';
  const value = isRTL ? tag.getAttribute('data-tag-ar') : tag.getAttribute('data-tag-en');

  if (!value || !value.trim()) {
    tag.style.display = 'none';
    return;
  }

  tag.style.display = '';
  text.textContent = value;

  if (text._raf) {
    cancelAnimationFrame(text._raf);
    text._raf = null;
  }

  const SPEED = 40;
  const wrapWidth = tag.clientWidth;
  const textWidth = text.scrollWidth;

  if (!wrapWidth || !textWidth) {
    text.style.left = '12px';
    text.style.transform = 'translateY(-50%)';
    return;
  }

  let x = isRTL ? -textWidth : wrapWidth;
  let lastTime = null;

  function tick(now) {
    if (!lastTime) lastTime = now;
    const dt = (now - lastTime) / 1000;
    lastTime = now;

    if (isRTL) {
      x += SPEED * dt;
      if (x > wrapWidth) x = -textWidth;
    } else {
      x -= SPEED * dt;
      if (x < -textWidth) x = wrapWidth;
    }

    text.style.left = x + 'px';
    text.style.transform = 'translateY(-50%)';
    text._raf = requestAnimationFrame(tick);
  }

  text.style.left = x + 'px';
  text.style.transform = 'translateY(-50%)';
  text._raf = requestAnimationFrame(tick);
}

function initRandomViewers(root) {
  const el = root.querySelector('[data-random-viewers]');
  if (!el) return;

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  el.textContent = randomInt(200, 1000);

  setInterval(function () {
    el.textContent = randomInt(200, 1000);
  }, 5000);
}

function initQuantity(root) {
  const minus = root.querySelector('[data-qty-minus]');
  const plus = root.querySelector('[data-qty-plus]');
  const input = root.querySelector('[data-qty-input]');

  if (!minus || !plus || !input) return;

  minus.addEventListener('click', function () {
    let value = parseInt(input.value || '1', 10);
    if (value > 1) input.value = value - 1;
  });

  plus.addEventListener('click', function () {
    let value = parseInt(input.value || '1', 10);
    input.value = value + 1;
  });

  input.addEventListener('input', function () {
    if (!input.value || parseInt(input.value, 10) < 1) {
      input.value = 1;
    }
  });
}

function initVariants(root) {
  const productRoot = root.querySelector('[data-pnew-product-root]');
  if (!productRoot) return;

  const optionButtons = Array.from(productRoot.querySelectorAll('[data-option-button]'));
  const variantInput = productRoot.querySelector('[data-variant-id-input]');
  const priceEl = productRoot.querySelector('[data-price]');
  const comparePriceEl = productRoot.querySelector('[data-compare-price]');
  const mainImage = root.querySelector('.pnew__main-image');
  const atcButton = productRoot.querySelector('.pnew__atc');
  const atcText = productRoot.querySelector('[data-atc-text]');

  if (!optionButtons.length || !variantInput) return;

  function updateUIFromButton(btn) {
    if (!btn) return;

    const variantId = btn.getAttribute('data-variant-id') || '';
    const variantPrice = Number(btn.getAttribute('data-variant-price') || 0);
    const variantComparePrice = Number(btn.getAttribute('data-variant-compare-price') || 0);
    const variantImage = btn.getAttribute('data-variant-image') || '';

    if (variantId) {
      variantInput.value = variantId;
    }

    if (priceEl && variantPrice > 0) {
      priceEl.textContent = formatMoneySimple(variantPrice);
    }

    if (comparePriceEl) {
      if (variantComparePrice > variantPrice) {
        comparePriceEl.textContent = formatMoneySimple(variantComparePrice);
        comparePriceEl.classList.remove('is-hidden');
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.classList.add('is-hidden');
      }
    }

    if (mainImage && variantImage) {
      mainImage.src = variantImage;
      mainImage.srcset = '';

      if (root._gallerySyncActiveThumbWithMainImage) {
        root._gallerySyncActiveThumbWithMainImage(true);
      } else if (root._galleryResetThumbsToStart) {
        root._galleryResetThumbsToStart();
      }
    }

    if (atcButton && atcText) {
      atcButton.disabled = false;
      atcText.textContent = document.documentElement.dir === 'rtl' ? 'أضف إلى السلة' : 'Add to cart';
    }
  }

  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const position = btn.getAttribute('data-option-position');

      optionButtons.forEach(function (item) {
        if (item.getAttribute('data-option-position') === position) {
          item.classList.remove('is-active');
        }
      });

      btn.classList.add('is-active');
      updateUIFromButton(btn);
    });
  });

  const initialActive =
    productRoot.querySelector('[data-option-button].is-active') ||
    optionButtons[0];

  if (initialActive) {
    updateUIFromButton(initialActive);
  }
}
function initProductForm(root) {
  const form = root.querySelector('.pnew__form');
  if (!form) return;

  const submitButton = form.querySelector('.pnew__atc');
  const submitText = form.querySelector('[data-atc-text]');
  const messageBox = form.querySelector('[data-form-message]');

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (!submitButton) return;

    const formData = new FormData(form);
    const originalText = submitText ? submitText.textContent : '';

    submitButton.disabled = true;

    if (messageBox) {
      messageBox.hidden = true;
      messageBox.textContent = '';
    }

    if (submitText) {
      submitText.textContent = document.documentElement.dir === 'rtl' ? 'جارٍ الإضافة...' : 'Adding...';
    }

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (json) {
            throw json;
          });
        }
        return response.json();
      })
      .then(function () {
        if (submitText) {
          submitText.textContent = document.documentElement.dir === 'rtl' ? 'تمت الإضافة' : 'Added';
        }

        return fetch('/cart.js');
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:count:update', {
          bubbles: true,
          detail: { item_count: cart.item_count }
        }));

        document.dispatchEvent(new CustomEvent('cart:reload', {
          bubbles: true,
          detail: cart
        }));

        document.dispatchEvent(new CustomEvent('currency:update', {
          bubbles: true
        }));

        const drawer =
          document.querySelector('hdt-cart-drawer') ||
          document.querySelector('#CartDrawer')?.closest('hdt-cart-drawer');

        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      })
      .catch(function (error) {
        if (messageBox) {
          messageBox.hidden = false;
          messageBox.textContent =
            (error && (error.description || error.message)) ||
            (document.documentElement.dir === 'rtl'
              ? 'حدث خطأ أثناء الإضافة إلى السلة'
              : 'Failed to add to cart');
        }
      })
      .finally(function () {
        setTimeout(function () {
          submitButton.disabled = false;
          if (submitText) submitText.textContent = originalText;
        }, 900);
      });
  });
}

function initReviewCount(root) {
  const countEl = root.querySelector('[data-review-count]');
  const badge = root.querySelector('.pnew__judge-badge-hidden');
  if (!countEl || !badge) return;

  function update() {
    const text = badge.textContent || '';
    const match = text.match(/\d+/);
    if (match && match[0]) {
      countEl.textContent = match[0];
    }
  }

  update();
  setTimeout(update, 1200);
  setTimeout(update, 2500);
}

function formatMoneySimple(cents) {
  if (typeof cents !== 'number') return '';

  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency:
        window.Shopify && Shopify.currency && Shopify.currency.active
          ? Shopify.currency.active
          : 'USD'
    }).format(cents / 100);
  } catch (e) {
    return (cents / 100).toFixed(2);
  }
}

function extractTikTokId(url) {
  if (!url) return null;
  let m = url.match(/\/video\/(\d+)/);
  if (m && m[1]) return m[1];
  m = url.match(/[?&]item_id=(\d+)/);
  if (m && m[1]) return m[1];
  return null;
}

function makeTikTokIframe(id, height) {
  const iframe = document.createElement('iframe');
  iframe.src = 'https://www.tiktok.com/player/v1/' + id + '?controls=1&description=0&music_info=0';
  iframe.allow = 'fullscreen';
  iframe.loading = 'lazy';
  iframe.style.border = '0';
  iframe.style.display = 'block';
  iframe.width = '100%';
  iframe.height = height || '100%';
  return iframe;
}

function initFloatingTikTok(root) {
  const floatBox = root.querySelector('[data-float-video]');
  if (!floatBox || floatBox.dataset.inited === 'true') return;
  floatBox.dataset.inited = 'true';

  const embed = floatBox.querySelector('.pdp-tiktok-float__embed');
  const toggleBtn = floatBox.querySelector('.pdp-tiktok-float__toggle');
  const iconEl = floatBox.querySelector('.pdp-tiktok-float__icon');

  if (embed) {
    const url = embed.getAttribute('data-tiktok-url');
    const id = extractTikTokId(url);

    if (!id) {
      embed.innerHTML = '<div style="padding:14px;color:#fff">استخدم رابط TikTok كامل</div>';
    } else {
      embed.innerHTML = '';
      embed.appendChild(makeTikTokIframe(id, '100%'));
    }
  }

  function setIcon(isMin) {
    if (!iconEl) return;
    iconEl.textContent = isMin
      ? iconEl.getAttribute('data-icon-play')
      : iconEl.getAttribute('data-icon-x');
  }

  if (toggleBtn) {
    setIcon(false);
    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const isMin = floatBox.classList.toggle('is-min');
      setIcon(isMin);
    });
  }
}

function initInlineTikTokEmbeds() {
  document.querySelectorAll('[data-inline-tiktok-url]').forEach(function (container) {
    if (container.dataset.inited === 'true') return;
    container.dataset.inited = 'true';

    const url = container.getAttribute('data-inline-tiktok-url');
    const id = extractTikTokId(url);

    if (!id) {
      container.innerHTML = '<div style="padding:14px;color:#fff">استخدم رابط TikTok كامل</div>';
      return;
    }

    container.innerHTML = '';
    container.appendChild(makeTikTokIframe(id, '520'));
  });
}

(function () {
  function extractTikTokId(url) {
    if (!url) return null;
    let m = url.match(/\/video\/(\d+)/);
    if (m && m[1]) return m[1];
    m = url.match(/[?&]item_id=(\d+)/);
    if (m && m[1]) return m[1];
    return null;
  }

  function makeTikTokIframe(id, height) {
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.tiktok.com/player/v1/' + id + '?controls=1&description=0&music_info=0';
    iframe.allow = 'fullscreen';
    iframe.loading = 'lazy';
    iframe.style.border = '0';
    iframe.style.display = 'block';
    iframe.width = '100%';
    iframe.height = height || '100%';
    return iframe;
  }

  function initFloatingTikTok() {
    const floatBox = document.querySelector('.pdp-tiktok-float[data-float-video]');
    if (!floatBox || floatBox.dataset.inited === 'true') return;
    floatBox.dataset.inited = 'true';

    const embed = floatBox.querySelector('.pdp-tiktok-float__embed');
    const toggleBtn = floatBox.querySelector('.pdp-tiktok-float__toggle');
    const iconEl = floatBox.querySelector('.pdp-tiktok-float__icon');

    if (embed) {
      const url = embed.getAttribute('data-tiktok-url');
      const id = extractTikTokId(url);

      if (!id) {
        embed.innerHTML = '<div style="padding:14px;color:#fff">استخدم رابط TikTok كامل</div>';
      } else {
        embed.innerHTML = '';
        embed.appendChild(makeTikTokIframe(id, '100%'));
      }
    }

    function setIcon(isMin) {
      if (!iconEl) return;
      iconEl.textContent = isMin
        ? iconEl.getAttribute('data-icon-play')
        : iconEl.getAttribute('data-icon-x');
    }

    setIcon(false);

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isMin = floatBox.classList.toggle('is-min');
        setIcon(isMin);
      });
    }
  }

  function initScrollingBadges() {
    document.querySelectorAll('.pnew-sb').forEach(function (root) {
      const oldRaf = root._sbRaf;
      if (oldRaf) cancelAnimationFrame(oldRaf);

      const wrap = root.querySelector('.pnew-sb__wrap');
      const track = root.querySelector('.pnew-sb__track');
      if (!wrap || !track) return;

      const originalHTML = track.innerHTML.trim();
      if (!originalHTML) return;

      track.innerHTML = originalHTML;

      let copies = 0;
      while (track.scrollWidth < wrap.clientWidth * 3 && copies < 20) {
        track.insertAdjacentHTML('beforeend', originalHTML);
        copies++;
      }

      const rtl = root.getAttribute('data-dir') === 'rtl';
      const SPEED = 35;
      let x = 0;
      let last = null;
      let paused = false;

      function getGap() {
        const s = getComputedStyle(track);
        return parseFloat(s.gap || s.columnGap || 0) || 0;
      }

      function tick(ts) {
        if (!last) last = ts;
        const dt = (ts - last) / 1000;
        last = ts;

        if (!paused) {
          const move = SPEED * dt;
          x += rtl ? move : -move;
          track.style.transform = `translateX(${x}px)`;

          const first = track.firstElementChild;
          const lastEl = track.lastElementChild;
          const gap = getGap();
          const wrapRect = wrap.getBoundingClientRect();

          if (!rtl && first) {
            const firstRect = first.getBoundingClientRect();
            if (firstRect.right <= wrapRect.left) {
              x += first.offsetWidth + gap;
              track.appendChild(first);
              track.style.transform = `translateX(${x}px)`;
            }
          }

          if (rtl && lastEl) {
            const lastRect = lastEl.getBoundingClientRect();
            if (lastRect.left >= wrapRect.right) {
              x -= lastEl.offsetWidth + gap;
              track.insertBefore(lastEl, track.firstChild);
              track.style.transform = `translateX(${x}px)`;
            }
          }
        }

        root._sbRaf = requestAnimationFrame(tick);
      }

      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      root.addEventListener('touchend', function () { paused = false; }, { passive: true });

      root._sbRaf = requestAnimationFrame(tick);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFloatingTikTok();
    initScrollingBadges();
  });
})();

document.addEventListener('click', async function (e) {
  const shareBtn = e.target.closest('[data-share-btn]');
  if (!shareBtn) return;

  const url = shareBtn.getAttribute('data-share-url');
  const title = shareBtn.getAttribute('data-share-title');

  try {
    if (navigator.share) {
      await navigator.share({ title, url });
    } else {
      await navigator.clipboard.writeText(url);
      alert(document.documentElement.lang === 'ar' ? 'تم نسخ الرابط' : 'Link copied');
    }
  } catch (err) {
    // ignore
  }
});















/* ===== FORCE PNEW PRICE UPDATE ON COLOR CLICK - START ===== */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.pnew__swatch[data-option-button]');
  if (!btn) return;

  const root = btn.closest('[data-pnew-root]');
  const productRoot = btn.closest('[data-pnew-product-root]');
  if (!root || !productRoot) return;

  const priceEl = productRoot.querySelector('[data-price]');
  const comparePriceEl = productRoot.querySelector('[data-compare-price]');
  const variantInput = productRoot.querySelector('[data-variant-id-input]');
  const mainImage = root.querySelector('.pnew__main-image');

  const variantId = btn.getAttribute('data-variant-id') || '';
  const variantPrice = Number(btn.getAttribute('data-variant-price') || 0);
  const variantComparePrice = Number(btn.getAttribute('data-variant-compare-price') || 0);
  const variantImage = btn.getAttribute('data-variant-image') || '';

  const samePosition = btn.getAttribute('data-option-position');

  root.querySelectorAll('.pnew__swatch[data-option-button]').forEach(function (item) {
    if (item.getAttribute('data-option-position') === samePosition) {
      item.classList.remove('is-active');
    }
  });

  btn.classList.add('is-active');

  if (variantInput && variantId) {
    variantInput.value = variantId;
  }

  if (priceEl && variantPrice > 0) {
    priceEl.textContent = formatMoneySimple(variantPrice);
  }

  if (comparePriceEl) {
    if (variantComparePrice > variantPrice) {
      comparePriceEl.textContent = formatMoneySimple(variantComparePrice);
      comparePriceEl.classList.remove('is-hidden');
      comparePriceEl.style.display = '';
    } else {
      comparePriceEl.textContent = '';
      comparePriceEl.classList.add('is-hidden');
      comparePriceEl.style.display = 'none';
    }
  }

  if (mainImage && variantImage) {
    mainImage.src = variantImage;
    mainImage.srcset = '';
  }

  if (root._gallerySyncActiveThumbWithMainImage) {
    root._gallerySyncActiveThumbWithMainImage(true);
  }
}, true);
/* ===== FORCE PNEW PRICE UPDATE ON COLOR CLICK - END ===== */